<template>
  <div id="appRoot" data-app>
    <v-dialog :value="!!active_ride_id" lazy @input="active_ride_id = null">
      <ride-page v-if="active_ride_id" show_end_ride :ride_id="active_ride_id" />
    </v-dialog>
    <template v-if="!$route.meta.public">
      <v-app
        id="inspire"
        class="app"
        v-if="$route && $route.name && $route.name.toLowerCase() !== 'root'"
      >
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar" style="z-index: 10"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <div class="page-wrapper">
            <div
              class="production-warning"
              v-if="api.PRODUCTION_WARNING && !hideProductionWarning"
              @click="hideProductionWarning = true"
              :title='$t("shell.clickToHide")'
            >
              {{ $t("shell.productionWarning") }}
            </div>
            <router-view :key="$route.fullPath"></router-view>
          </div>
        </v-content>
        <app-fab></app-fab>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      v-for="(snackbar, i) of snackbars"
      :key="'sanackbar-' + i"
      :timeout="snackbar.timeout ? snackbar.timeout : 3000"
      :color="snackbar.color"
      v-model="snackbar.show"
      v-bind="snackbar"
    >
      {{ snackbar.text }}
      <v-btn v-if="snackbar.action" dark flat @click="snackbar.action"> {{ $t("shell.show") }} </v-btn>
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <suggest-popup
      v-for="suggest in suggestPopups"
      :key="'suggest' + suggest.id"
      :data="suggest"
      @snooze="removeSuggestion(suggest.id)"
    />
    <confirm-passenger-dialog
      :settings.sync="confirm_passenger_dialog"
    ></confirm-passenger-dialog>
    <v-dialog lazy :value="tickets.length > 0" @input="tickets = tickets.slice(1)">
      <v-card v-if="tickets.length > 0">
        <v-card-title primary-title class="font-weight-bold secondary">
          {{ $t("shell.newTicket") }}
        </v-card-title>
        <v-card-title primary-title class="font-weight-bold primary">
          {{ tickets[0].type.title }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6> {{ $t("shell.name") }} </v-flex>
            <v-flex xs6>
              {{ tickets[0].author.first_name }}
              {{ tickets[0].author.last_name }}
            </v-flex>
            <v-flex xs6> {{ $t("shell.type") }} </v-flex>
            <v-flex xs6>
              {{ tickets[0].author_type.split("App\\Models\\")[1] }}
            </v-flex>
            <template v-if="tickets[0].subject">
              <v-flex xs6> {{ $t("shell.onType") }} </v-flex>
              <v-flex xs6>
                {{ tickets[0].subject_type.split("App\\Models\\")[1] }}
              </v-flex>
              <v-flex xs6> {{ $t("shell.onIdentifier") }} </v-flex>
              <v-flex xs6>
                <template v-if="tickets[0].subject.first_name">
                  {{ tickets[0].subject.first_name }}
                  {{ tickets[0].subject.last_name }}
                </template>
                ({{ tickets[0].subject_id }})
              </v-flex>
            </template>
            <v-flex xs6> {{ $t("shell.creationDate") }} </v-flex>
            <v-flex xs6>
              {{ $companyTime(tickets[0].created_at, "YYYY-MM-DD HH:mm") }}
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="text-xs-center">
          <v-btn
            v-if="tickets[0].status === 'PENDING'"
            flat
            color="primary"
            @click="clickTicket(tickets[0])"
          >
            {{ $t("shell.assignToMe") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Dialog />
   
  </div>
</template>
<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import Dialog from "@/components/Dialog";
import AppFab from "@/components/AppFab";
import AppEvents from "@/event";
import Login from "./views/Login";
import { mapState } from "vuex";
import * as Mapbox from "mapbox-gl";
import SuggestPopup from "@/components/widgets/SuggestPopup";
import { formatCompanyTime } from "@/util/companyTime";
import socketEventsMixin from "@/mixins/socketEventsMixin";
import ConfirmPassengerDialog from "@/components/monaco/input/ConfirmPassengerDialog";
import RidePage from "@/views/RidePage";

export default {
  mixins: [socketEventsMixin],
  components: {
    ConfirmPassengerDialog,
    Login,
    RidePage,
    AppDrawer,
    AppToolbar,
    AppFab,
    SuggestPopup,
    Dialog
    
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbars: [],
    active_ride_id: null,
    suggestPopups: [],
    confirm_passenger_dialog: {
      visible: false,
      passenger_id: null,
    },
    tickets: [],
    hideProductionWarning: false,
  }),
  computed: mapState(["notifications"]),
  created() {
    AppEvents.forEach((item) => this.$on(item.name, item.callback));
    window.getApp = this;
    Mapbox.setRTLTextPlugin(
      "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js"
    );
    // console.log("besoins");
    // this.getBesoins();
  },
  mounted() {
   // console.log("besoins");
    // this.getBesoins();
  },
  methods: {
    // getBesoins() {
    //   this.axios
    //     .get(`besoin/user`)
    //     .then((data) => {
    //       var besoins = data.data.data;
    //       console.log(besoins);
    //       console.log(this.$store.state.besoins);
    //       // foreach(besoins);
    //       for (let i = 0; i < besoins.length; i++) {
    //         this.$store.commit("SET_BESOIN", besoins[i]);
    //       }
    //       // this.$store.commit("SET_BESOIN", besoins);
    //     })
    //     .catch((err) => {
    //       window.getApp.$emit("SHOW_TOAST", err, "red");
    //     });
    // },
    removeSuggestion(elId) {
      this.suggestPopups = this.suggestPopups.filter(({ id }) => id !== elId);
    },
    newSuggestion(suggestion) {
      this.suggestPopups = [...this.suggestPopups, suggestion];
    },
    newPassenger(passenger) {
      if (passenger.id_card_front || passenger.id_card_back) {
        this.confirm_passenger_dialog.passenger_id = passenger.id;
        this.confirm_passenger_dialog.visible = true;
      }
    },
    lateBooking(data) {
      data.forEach(({ captain_name, datetime, booking_id, ride_id }) =>
        this.$emit(
          "SHOW_TOAST",
          this.$t("shell.lateBookingToast", {
            captain: captain_name,
            // Final-version doc 2026-10-05: company clock (UTC+3).
            time: formatCompanyTime(datetime, "HH:mm"),
          }),
          "orange",
          ["bottom", "left"],
          10000,
          () => (this.active_ride_id = ride_id)
        )
      );
    },
    lateCaptain(data) {
      data.forEach(({ captain_name, passenger_name, datetime, booking_id, ride_id }) =>
        this.$emit(
          "SHOW_TOAST",
          this.$t("shell.lateCaptainToast", {
            captain: captain_name,
            passenger: passenger_name,
            time: formatCompanyTime(datetime, "HH:mm"),
          }),
          "red",
          ["bottom", "left"],
          10000,
          () => (this.active_ride_id = ride_id)
        )
      );
    },
    newTicket(ticket) {
      this.tickets = [...this.tickets, ticket];
    },
    dismissTicket(ticketId) {
      this.tickets = this.tickets.filter((x) => x.id != ticketId);
    },
    clickTicket(ticket) {
      this.loading = true;
      this.axios
        .put(this.api.ACTIONS.TICKET_ASSIGN(ticket.id))
        .then(() => {
          this.tickets = this.tickets.filter((t) => t.id != ticket.id);
          let routeData = this.$router.resolve({
            name: "Ticket",
            params: { id: ticket.id },
          });
          window.open(routeData.href, "_blank");
        })
        .finally(() => (this.loading = false));
    },
    renewBesoin(besoin) {
      // this.$store.commit("SET_BESOIN", besoin.booking_id);
      // console.log(this.$store.state.besoins);

      this.$dialova({
        title: this.$t("shell.keepOrderTitle", { id: besoin.booking_id }),
        paragraph: this.$t("shell.keepOrderParagraph", { id: besoin.booking_id }),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .post(`besoin/renew/${besoin.booking_id}`)
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("shell.orderExtended", { id: besoin.booking_id }),
                "green"
              );
              // this.$store.commit("DELETE_BESOIN", besoin.booking_id);
              close();
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
            });
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
    expiredBesoin(besoin) {
      this.$store.commit("DELETE_BESOIN", besoin.booking_id);
      console.log(this.$store.state.besoins);
    },
  },
  watch: {
    notifications(newValue, oldValue) {
      for (let i = oldValue.length; i < newValue.length; i++)
        this.$emit(
          "SHOW_TOAST",
          newValue[i].message,
          newValue[i].color,
          ["bottom", "left"],
          newValue[i].timeout
        );
    },
  },
  events() {
    if (this.$store.state.user && [11, 12].includes(this.$store.state.user.roles[0].id)) {
      return {};
    }
    // 'Ai:new_now_booking' is deliberately not handled here. The backend
    // emits it on every new booking; the legacy SnoozePopup it used to open
    // read fields that payload never carries, so each booking left an
    // invisible, erroring popup with a 1 s timer in every open tab. The order
    // boards (InstantOrders / ReservationOrders) subscribe to it themselves.
    return {
      "Ai:new_suggestion": this.newSuggestion,
      "Ai:pass_suggestion": this.removeSuggestion,
      "Dashboard:new_passenger": this.newPassenger,
      [this.api.SOCKET.EVENTS.LATE_BOOKING]: this.lateBooking,
      [this.api.SOCKET.EVENTS.LATE_CAPTAIN]: this.lateCaptain,
      [this.api.SOCKET.EVENTS.NEW_TICKET]: this.newTicket,
      [this.api.SOCKET.EVENTS.DISMISS_TICKET]: this.dismissTicket,
      [this.api.SOCKET.EVENTS.RENEW_BESOIN]: this.renewBesoin,
      [this.api.SOCKET.EVENTS.EXPIRED_BESOIN]: this.expiredBesoin,
    };
  },
};
</script>

<style lang="scss">
$namespace: "xmx";

$default-color: #555;
$primary-color: #27a432;

.#{$namespace}-table-date {
  .today {
    color: $primary-color;
    border: 1px solid $primary-color;
  }
}

.#{$namespace}-input {
  padding: 26px !important;
  padding-inline-start: 18px !important;
  height: auto;
  border: none !important;
}

.#{$namespace}-icon-calendar,
.#{$namespace}-icon-clear {
  inset-inline-end: 18px !important;
}

@import "~vue2-datepicker/scss/index.scss";

.setting-fab {
  top: 50% !important;
  inset-inline-end: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px);
}

.page-wrapper .production-warning {
  background-color: #f7c600;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 12px;
  border-radius: 8px;
  animation-name: warning;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  cursor: pointer;
}

@keyframes warning {
  from {
    transform: translateX(-50%) scale(0.98);
  }
  to {
    transform: translateX(-50%) scale(1.02);
  }
}

.full-width {
  width: 100% !important;
}
.application {
  font-family: "Poppins";
}
.headline,
.title,
.subheading {
  font-family: poppins !important;
}

/* ------------------------------------------------------------------ */
/* Full borders on every dashboard data table (QA request 2026-07-15): */
/* the table and each cell get a visible frame, in RTL and LTR alike.  */
/* ------------------------------------------------------------------ */
table.v-table {
  border-collapse: collapse !important;
  border: 1px solid rgba(0, 0, 0, 0.28) !important;
}
table.v-table thead th,
table.v-table thead td,
table.v-table tbody th,
table.v-table tbody td {
  border: 1px solid rgba(0, 0, 0, 0.28) !important;
}
table.v-table thead th {
  background: #f4f6f8;
}

</style>
